/**
 * Web fonts per script (docs/contributing/i18n.md, "Fonts"): Inter carries Latin, Greek, Cyrillic and Vietnamese;
 * other scripts load their Noto family (self-hosted @fontsource-variable packages, split by unicode-range so the
 * browser fetches only the slices a page uses) when a locale that needs it is chosen. `data-script` on <html> puts
 * the family into --font-script (i18n.css); characters Inter lacks fall through to it.
 */
const LOADERS: Record<string, () => Promise<unknown>> = {
  arabic: () => import("@fontsource-variable/noto-sans-arabic"),
  hebrew: () => import("@fontsource-variable/noto-sans-hebrew"),
  devanagari: () => import("@fontsource-variable/noto-sans-devanagari"),
  thai: () => import("@fontsource-variable/noto-sans-thai"),
  "simplified-chinese": () => import("@fontsource-variable/noto-sans-sc"),
  japanese: () => import("@fontsource-variable/noto-sans-jp"),
  korean: () => import("@fontsource-variable/noto-sans-kr"),
};

const loaded = new Set<string>();

/** Loads the script's font (once) and marks the page with it. Latin, Greek and Cyrillic need nothing. */
export function loadScriptFont(script: string): void {
  document.documentElement.dataset.script = script;
  const load = LOADERS[script];
  if (!load || loaded.has(script)) return;
  loaded.add(script);
  load().catch(() => loaded.delete(script)); // offline: the system font of the script stands in
}

export const SCRIPTS_WITH_FONTS = Object.keys(LOADERS);
